module.exports = __webpack_public_path__ + "img/marker-pin-pr.bcdda50f.svg";